define(['underscore'], (_) => {

    return {

        $get: ['ModalService', '$filter', '$state', 'state_plugin_config', function (ModalService, $filter, $state, statePluginConfig) {

            const quoteTimeout = function () {
                ModalService.showError(
                    $filter('translate')('platform.base.DefaultErrorHandlerService.Session Timeout'),
                    $filter('translate')('platform.base.DefaultErrorHandlerService.Sorry, your session has timed out. Please restart your quote.')
                ).result.then(() => {
                    $state.transitionTo(statePluginConfig.home);
                });
            };

            let retriableErrorPopup; //one popup at one moment
            const retriableError = function () {

                if (!retriableErrorPopup) {
                    retriableErrorPopup = ModalService.showError(
                        $filter('translate')('platform.basler.DefaultErrorHandlerService.Retriable Error'),
                        $filter('translate')('platform.basler.DefaultErrorHandlerService.Retriable Error.Please retry')
                    );
                    retriableErrorPopup.result.then(() => {
                        retriableErrorPopup = null;
                    });
                }

            };

            return {

                /**
                 * @param error object
                 * @returns returns function to handle error or NULL/Empty function
                 */
                getErrorHandlerForError: function (error) {
                    if (error.handled) {
                        return _.noop;
                    }
                    switch (error) { //NOSONAR
                        case -33004:
                            error.handled = true;
                            return quoteTimeout;
                        default:
                            if (error.isRetriable) {
                                error.handled = true;
                                return retriableError;
                            } 
                                return _.noop;
                            
                    }
                },
            };

        }],
    };
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/base/DefaultErrorHandlerService.js